/**
 * Email Action Modal Component
 * used when the state of a record changes, which also fires off an email.
 * The modal is used as confirmation of the state change, and also to
 * collect form input for the email (notes etc.)
 */

import Button from '@/gf/components/ButtonOld'
import Modal from '@/gf/components/Modal'
import Spinner from '@/gf/components/Spinner'

import CustomerComments from './CustomerComments'

import { EmailActionModalC } from '../../types'

const EmailActionModal: EmailActionModalC = ({
  open,
  onClose,
  title,
  onSubmit,
  submitButtonText = 'Submit',
  isWaiting,
  emailText,
  setEmailText,
  sendEmailCheckbox,
  setSendEmailCheckbox,
  hideNotificationOption,
  children,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    footerAction={<Button title={submitButtonText} onClick={onSubmit} disabled={isWaiting} />}
  >
    {isWaiting ? (
      <Spinner />
    ) : (
      <>
        {children}
        {!hideNotificationOption && (
          <CustomerComments
            send={sendEmailCheckbox}
            setSend={setSendEmailCheckbox}
            comments={emailText}
            setComments={setEmailText}
          />
        )}
      </>
    )}
  </Modal>
)

export default EmailActionModal
